import { z } from "zod";

export const getNewsletterSchema = (
  t?: (key: string) => string,
  brand?: string
) => {
  const brandValue = brand;

  const baseSchema = z.object({
    email: z.string().min(1, {
      message: t ? t("errorMessages.fieldError") : "Email is required",
    }),
    country: z.string().min(0, {
      message: t ? t("errorMessages.fieldError") : "Country is required",
    }),
    interest: z.array(z.string()).optional(),
    hasPrivacyPolicy: z.boolean().refine((val) => val === true, {
      message: t
        ? t("errorMessages.privacyPolicyError")
        : "Please agree with the privacy policy",
    }),
    preferredLanguage: z.string().min(1, {
      message: t
        ? t("errorMessages.fieldError")
        : "Preferred language is required",
    }),
    ietf_language_tag: z.string().min(1, {
      message: t
        ? t("errorMessages.fieldError")
        : "IETF language tag is required",
    }),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    phoneNumber: z.string().optional(),
  });

  const brandSchemas: Record<string, () => z.ZodTypeAny> = {
    scott: () =>
      baseSchema.extend({
        interest: z.array(z.string()).min(1, {
          message: t ? t("errorMessages.fieldError") : "Interest is required",
        }),
      }),
    dolomite: () => baseSchema,
  };

  return brandValue && brandSchemas[brandValue]
    ? brandSchemas[brandValue]()
    : baseSchema;
};

export const UserNewsletterRequestSchema = z.object({
  email: z
    .string()
    .email({ message: "Invalid email address" })
    .optional()
    .nullable(),
  uid: z.string().optional().nullable(),
  brand: z.string(),
});

export type UserNewsletterRequest = z.infer<typeof UserNewsletterRequestSchema>;
